export default __webpack_public_path__ + "static/media/Portal_Exam.6d97875f.svg";